import type { Email, EmailAction, EmailTemplate } from './emailTypes';
import { EmailActionTypes as actionTypes } from './emailTypes';

export const emailSendEmailsRequest = (payload: {
	emails: Email[];
	isReply?: boolean;
}): EmailAction => ({
	type: actionTypes.EMAIL_SEND_EMAILS_REQUEST,
	payload
});

export const emailSendEmailsSuccess = (payload: Email[]): EmailAction => ({
	type: actionTypes.EMAIL_SEND_EMAILS_SUCCESS,
	payload
});

export const emailSendEmailsFailure = (error: any): EmailAction => ({
	type: actionTypes.EMAIL_SEND_EMAILS_FAILURE,
	error
});

export const emailClearEmailsStatus = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_EMAILS_STATUS
});

export const emailUpdateEmail = (payload: Email): EmailAction => ({
	type: actionTypes.EMAIL_UPDATE_EMAIL,
	payload
});

export const emailResetEmail = (): EmailAction => ({
	type: actionTypes.EMAIL_RESET_EMAIL
});

export type EmailGetEmailThreadProps = {
	businessId: string;
	userEmail: string;
};

export const emailGetEmailThread = (
	payload: EmailGetEmailThreadProps
): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_THREAD,
	payload
});

export const emailGetEmailContactedStatus = (payload: {
	toEmail: string;
}): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_CONTACTED_STATUS,
	payload
});

export const emailGetEmailContactedStatusLoading = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_CONTACTED_STATUS_LOADING
});

export const emailGetEmailContactedStatusSuccess = (payload: {
	emailContacted: boolean;
	lastContactedDate: string;
}): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_CONTACTED_STATUS_SUCCESS,
	payload
});

export const emailGetEmailContactedStatusFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_CONTACTED_STATUS_FAILURE
});

export const emailClearEmailContactedStatus = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_EMAIL_CONTACTED_STATUS
});

export const emailSetMessageId = (payload): EmailAction => ({
	type: actionTypes.EMAIL_REPLY_MESSAGE_ID,
	payload
});

export const emailSetSubjectForEmail = (payload): EmailAction => ({
	type: actionTypes.EMAIL_ADD_REPLY_SUBJECT_FOR_EMAIL,
	payload
});

export const emailRemoveSubjectForEmail = (): EmailAction => ({
	type: actionTypes.EMAIL_REMOVE_REPLY_SUBJECT_FOR_EMAIL
});

export const emailGetEmailTemplatesRequest = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATES_REQUEST
});

export const emailGetEmailTemplatesSuccess = (
	payload: EmailTemplate[]
): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATES_SUCCESS,
	payload
});

export const emailGetEmailTemplatesFailure = (error: Error): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATES_FAILURE,
	error
});

export const emailCreateEmailTemplateRequest = (
	payload: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_CREATE_EMAIL_TEMPLATE_REQUEST,
	payload
});

export const emailCreateEmailTemplateSuccess = (
	payload: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_CREATE_EMAIL_TEMPLATE_SUCCESS,
	payload
});

export const emailCreateEmailTemplateFailure = (error: Error): EmailAction => ({
	type: actionTypes.EMAIL_CREATE_EMAIL_TEMPLATE_FAILURE,
	error
});

export const emailUpdateEmailTemplateRequest = (
	payload: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_UPDATE_EMAIL_TEMPLATE_REQUEST,
	payload
});

export const emailUpdateEmailTemplateSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_UPDATE_EMAIL_TEMPLATE_SUCCESS,
	payload
});

export const emailUpdateEmailTemplateFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_UPDATE_EMAIL_TEMPLATE_FAILURE
});

export const emailDeleteEmailTemplateRequest = (
	payload: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_DELETE_EMAIL_TEMPLATE_REQUEST,
	payload
});

export const emailDeleteEmailTemplateSuccess = (
	payload?: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_DELETE_EMAIL_TEMPLATE_SUCCESS,
	payload
});

export const emailDeleteEmailTemplateFailure = (error: Error): EmailAction => ({
	type: actionTypes.EMAIL_DELETE_EMAIL_TEMPLATE_FAILURE,
	error
});

export const emailDuplicateEmailTemplateSuccess = (
	payload?: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_DUPLICATE_EMAIL_TEMPLATE_SUCCESS,
	payload
});

export const emailDuplicateEmailTemplateRequest = (
	payload: EmailTemplate
): EmailAction => ({
	type: actionTypes.EMAIL_DUPLICATE_EMAIL_TEMPLATE_REQUEST,
	payload
});

export const emailDuplicateEmailTemplateFailure = (
	error: Error
): EmailAction => ({
	type: actionTypes.EMAIL_DUPLICATE_EMAIL_TEMPLATE_FAILURE,
	error
});

export const emailGetEmailStatuses = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_STATUSES
});

export const emailGetEmailStatusesLoading = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_STATUSES_LOADING
});

export const emailGetEmailStatusesSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_STATUSES_SUCCESS,
	payload
});

export const emailGetEmailStatusesFailure = (error: Error): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_STATUSES_FAILURE,
	error
});

export const emailClearEmailStatuses = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_EMAIL_STATUSES
});

export const emailClearEmailQueue = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_EMAIL_QUEUE
});

export const emailGetScheduledEmailLimits = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAIL_LIMITS
});

export const emailGetScheduledEmailLimitsSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAIL_LIMITS_SUCCESS,
	payload
});

export const emailSendScheduledEmailSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_SEND_SCHEDULED_EMAIL_SUCCESS,
	payload
});

export const emailSendScheduledEmailFailure = (payload): EmailAction => ({
	type: actionTypes.EMAIL_SEND_SCHEDULED_EMAIL_FAILURE,
	payload
});

export const emailSendScheduledEmailClearFailureStatus = (): EmailAction => ({
	type: actionTypes.EMAIL_SEND_SCHEDULED_EMAIL_CLEAR_FAILURE_STATUS
});

export const emailGetScheduledEmails = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS,
	payload
});

export const emailGetScheduledEmailsSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_SUCCESS,
	payload
});

export const emailGetScheduledEmailsFailure = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_FAILURE,
	payload
});

export const emailGetScheduledEmailsCountByDate = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_COUNT_BY_DATE,
	payload
});

export const emailGetScheduledEmailsCountByDateSuccess = (
	payload
): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_COUNT_BY_DATE_SUCCESS,
	payload
});

export const emailGetScheduledEmailsCountByTimePeriod = (
	payload
): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_COUNT_BY_TIME_PERIOD,
	payload
});

export const emailGetScheduledEmailsCountByTimePeriodSuccess = (
	payload
): EmailAction => ({
	type: actionTypes.EMAIL_GET_SCHEDULED_EMAILS_COUNT_BY_TIME_PERIOD_SUCCESS,
	payload
});

export const emailCancelScheduledBatchEmailsAdmin = (payload): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_ADMIN,
	payload
});

export const emailCancelScheduledBatchEmailsAdminSuccess = (payload: {
	successfulCancellations: number;
	failedCancellations: number;
}): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_ADMIN_SUCCESS,
	payload
});

export const emailCancelScheduledBatchEmailsAdminFailure = (
	payload
): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_ADMIN_FAILURE,
	payload
});

export const emailCancelScheduledBatchEmailsUser = (payload): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_USER,
	payload
});

export const emailCancelScheduledBatchEmailsUserSuccess = (
	payload
): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_USER_SUCCESS,
	payload
});

export const emailCancelScheduledBatchEmailsUserFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_USER_FAILURE
});

export const emailCancelScheduledBatchEmailsClearStatus = (): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_BATCH_EMAILS_CLEAR_STATUS
});

export const emailCancelScheduledEmail = (payload): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_EMAIL,
	payload
});

export const emailCancelScheduledEmailSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_EMAIL_SUCCESS,
	payload
});

export const emailCancelScheduledEmailFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_EMAIL_FAILURE
});

export const emailCancelScheduledEmailClearStatus = (): EmailAction => ({
	type: actionTypes.EMAIL_CANCEL_SCHEDULED_EMAIL_CLEAR_STATUS
});

export const emailGetEmailTemplateScores = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATE_SCORES,
	payload
});

export const emailGetEmailTemplateScoresSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATE_SCORES_SUCCESS,
	payload
});

export const emailGetEmailTemplateScoresFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_EMAIL_TEMPLATE_SCORES_FAILURE
});

export const emailClearEmailTemplateScores = () => ({
	type: actionTypes.EMAIL_CLEAR_EMAIL_TEMPLATE_SCORES
});

export const emailIncreaseEmailTemplateUsage = (payload): EmailAction => ({
	type: actionTypes.EMAIL_INCREASE_EMAIL_TEMPLATE_USAGE,
	payload
});

export const emailClearStaleTemplateState = () => ({
	type: actionTypes.EMAIL_CLEAR_STALE_TEMPLATE_STATE
});

export const emailClearUnstaledTemplate = () => ({
	type: actionTypes.EMAIL_CLEAR_UNSTALED_TEMPLATE
});

export const emailClearLastStaledTemplate = () => ({
	type: actionTypes.EMAIL_CLEAR_LAST_STALED_TEMPLATE
});

export const emailSendAll = (payload): EmailAction => ({
	type: actionTypes.EMAIL_SEND_ALL,
	payload
});

export const emailSendAllSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_SEND_ALL_SUCCESS,
	payload
});

export const emailSendAllFailure = (payload): EmailAction => ({
	type: actionTypes.EMAIL_SEND_ALL_FAILURE,
	payload
});

export const emailSendAllClear = (): EmailAction => ({
	type: actionTypes.EMAIL_SEND_ALL_CLEAR
});

export const emailGetAISnippets = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_AI_SNIPPETS,
	payload
});

export const emailGetAISnippetsSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_AI_SNIPPETS_SUCCESS,
	payload
});

export const emailDeleteAISnippets = (payload): EmailAction => ({
	type: actionTypes.EMAIL_DELETE_AI_SNIPPETS,
	payload
});

export const emailRegenAISnippet = (payload): EmailAction => ({
	type: actionTypes.EMAIL_REGENERATE_AI_SNIPPET,
	payload
});

export const emailRegenAISnippetSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_REGENERATE_AI_SNIPPET_SUCCESS,
	payload
});

export const emailRegenAISnippetFailure = (payload): EmailAction => ({
	type: actionTypes.EMAIL_REGENERATE_AI_SNIPPET_FAILURE,
	payload
});

export const emailGetAICredits = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_AI_CREDITS
});

export const emailGetAICreditsSuccess = (payload): EmailAction => ({
	type: actionTypes.EMAIL_GET_AI_CREDITS_SUCCESS,
	payload
});

export const emailClearAIRegenerate = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_AI_REGENERATE
});

export const emailClearAISnippetsSuccess = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_AI_SNIPPETS_SUCCESS
});

export const emailRevertAITemplate = (): EmailAction => ({
	type: actionTypes.EMAIL_REVERT_AI_TEMPLATE
});

export const emailClearRevertAITemplate = (): EmailAction => ({
	type: actionTypes.EMAIL_CLEAR_REVERT_AI_TEMPLATE
});

export type EmailSendCustomerReportBadDataProps = {
	businessId: string;
	incorrectData: string;
	userEmail: string;
	additionalString?: string;
};

export const emailSendCustomerReportBadData = (
	payload: EmailSendCustomerReportBadDataProps
): EmailAction => ({
	type: actionTypes.EMAIL_SEND_CUSTOMER_REPORT_BAD_DATA,
	payload
});

export const emailSendCustomerReportBadDataSuccess = (): EmailAction => ({
	type: actionTypes.EMAIL_SEND_CUSTOMER_REPORT_BAD_DATA_SUCCESS
});

export const emailSendCustomerReportBadDataFailure = (): EmailAction => ({
	type: actionTypes.EMAIL_SEND_CUSTOMER_REPORT_BAD_DATA_FAILURE
});

export const emailSendCustomerReportBadDataClear = (): EmailAction => ({
	type: actionTypes.EMAIL_SEND_CUSTOMER_REPORT_BAD_DATA_CLEAR
});

export const emailGetMonthlyEmailLimit = (): EmailAction => ({
	type: actionTypes.EMAIL_GET_MONTHLY_EMAIL_LIMIT
});

export const emailGetMonthlyEmailLimitSuccess = (
	payload: string
): EmailAction => ({
	type: actionTypes.EMAIL_GET_MONTHLY_EMAIL_LIMIT_SUCCESS,
	payload
});
